import {
  createVariableMap
} from "./chunk-UA42UUKW.mjs";
import {
  effect
} from "./chunk-RN74DUWM.mjs";

// src/tokens/vars/effectVars.ts
var effectVars = createVariableMap(effect, "stack-semantic");

export {
  effectVars
};
